{
  "name": "@open-event/source",
  "version": "2.1.0",
  "license": "MIT",
  "scripts": {},
  "private": true,
  "dependencies": {
    "@angular/animations": "22.2.3",
    "@angular/cdk": "22.2.4",
    "@angular/common": "22.2.3",
    "@angular/compiler": "22.2.3",
    "@angular/core": "22.2.3",
    "@angular/forms": "22.2.3",
    "@angular/material": "22.2.4",
    "@angular/material-luxon-adapter": "22.2.4",
    "@angular/platform-browser": "22.2.3",
    "@angular/platform-browser-dynamic": "22.2.3",
    "@angular/router": "22.2.3",
    "@fortawesome/angular-fontawesome": "^5.1.0",
    "@fortawesome/fontawesome-svg-core": "^7.3.1",
    "@fortawesome/free-brands-svg-icons": "^7.3.1",
    "@fortawesome/free-solid-svg-icons": "^7.3.1",
    "@ngneat/overview": "^8.1.0",
    "@ngx-translate/core": "^18.0.0",
    "@ngx-translate/http-loader": "^18.0.0",
    "@ngxpert/hot-toast": "^7.0.0",
    "@types/leaflet.markercluster": "^1.5.6",
    "driver.js": "^1.10.2",
    "echarts": "^6.1.0",
    "file-saver": "^2.0.5",
    "keycloak-angular": "^22.0.0",
    "keycloak-js": "^26.2.4",
    "leaflet": "^1.9.4",
    "leaflet.markercluster": "^1.5.3",
    "luxon": "^3.7.2",
    "ngx-echarts": "^22.0.0",
    "ngx-gravatar": "^13.0.0",
    "ngx-quill": "^31.0.1",
    "quill": "^2.0.3",
    "rxjs": "~7.8.2",
    "tailwind-scrollbar": "^4.0.2",
    "zone.js": "0.16.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "22.2.4",
    "@angular-devkit/core": "22.2.4",
    "@angular-devkit/schematics": "22.2.4",
    "@angular/cli": "22.2.4",
    "@angular/compiler-cli": "22.2.3",
    "@angular/language-service": "22.2.3",
    "@eslint/js": "^10.0.1",
    "@nx/angular": "24.0.1",
    "@nx/eslint": "24.0.1",
    "@nx/eslint-plugin": "24.0.1",
    "@nx/jest": "24.0.1",
    "@nx/js": "24.0.1",
    "@nx/web": "24.0.1",
    "@nx/workspace": "24.0.1",
    "@schematics/angular": "22.2.4",
    "@swc-node/register": "1.12.1",
    "@swc/core": "1.16.20",
    "@swc/helpers": "0.5.23",
    "@tailwindcss/postcss": "^4.3.3",
    "@tailwindcss/typography": "^0.5.20",
    "@types/file-saver": "^2.0.7",
    "@types/jest": "30.0.0",
    "@types/leaflet": "^1.9.22",
    "@types/luxon": "^3.7.6",
    "@types/node": "24.19.2",
    "@typescript-eslint/utils": "8.72.0",
    "angular-eslint": "22.6.0",
    "autoprefixer": "^10.6.1",
    "eslint": "^10.13.0",
    "eslint-config-prettier": "10.1.8",
    "jest": "30.5.2",
    "jest-environment-jsdom": "30.5.2",
    "jest-preset-angular": "17.0.3",
    "jest-util": "30.5.1",
    "nx": "24.0.1",
    "postcss": "^8.5.31",
    "prettier": "^3.9.10",
    "tailwindcss": "^4.3.3",
    "ts-jest": "29.4.15",
    "ts-node": "10.9.2",
    "tslib": "^2.8.1",
    "typescript": "~6.0.3",
    "typescript-eslint": "8.72.0"
  },
  "overrides": {
    "@babel/core": "^7.29.7"
  },
  "allowScripts": {
    "less@4.5.1": true,
    "@parcel/watcher@2.6.0": true,
    "@swc/core@1.16.18": true,
    "esbuild@0.28.2": true,
    "esbuild@0.27.7": true,
    "lmdb@3.5.6": true,
    "msgpackr-extract@3.0.4": true,
    "nx@23.3.0": true,
    "unrs-resolver@1.12.2": true
  }
}
